import React from 'react';
import * as PropTypes from 'prop-types';

const A = (
  {
    tag: Tag = 'div',
    href,
    onClick,
    children,
    ...props
  }
) => {
  return (
    <Tag
      {...props}
      onClick={
        (e) => {
          if (onClick && onClick.call) {
            onClick.call(null, e);
          }
          window.location.href = href;
        }
      }
    >
      {children}
    </Tag>
  );
};

A.propTypes = {
  tag: PropTypes.string,
  href: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
};

export default A;
